module.exports = __webpack_public_path__ + "img/emt_progetto.6010cc6b.png";